











import "@/assets/project.scss";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AppError from "@/components/AppError.vue";
import ProjectTypes from "@/components/ProjectTypes.vue";
import StoreList from "@/components/StoreList.vue";
import { MapStoreModule } from "@/store/modules/mapStore";
import GoogleMapWrap from "@/components/GoogleMapWrap.vue";

@Component({
  components: {
    AppError,
    ProjectTypes,
    StoreList,
    GoogleMapWrap
  }
})
export default class ZipcodeMap extends Vue {
  private configs = Vue.prototype.$globalConfig

  get isDataRequest(): boolean {
    return MapStoreModule.isRequest;
  }

  get existStores(): boolean {
    return MapStoreModule.isActiveStatus;
  }
}
